import React, { useState, useRef, useEffect } from "react";
import "../Styling/SearchableDropdown.css";

const SearchableDropdown = ({
  label,
  options = [],
  value,
  onChange,
  placeholder = "Search resource...",
  optionLabel = "resourceName",
  optionValue = "resourceId",
}) => {
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const ref = useRef();

  /* Close on outside click */
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setShow(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  /* Reset display text when value cleared externally */
  useEffect(() => {
    if (!value) setSearch("");
  }, [value]);

  const filtered = options.filter((opt) =>
    `${opt[optionValue]} ${opt[optionLabel]}`
      .toLowerCase()
      .includes(search.toLowerCase()),
  );

  const handleSelect = (opt) => {
    setSearch(`${opt[optionValue]} - ${opt[optionLabel]}`);
    onChange({ target: { value: opt[optionValue] } });
    setShow(false);
  };

  const visibleOptions = search ? filtered : options;

  return (
    <div className="pac-dropdown__root" ref={ref}>
      {label && <label className="pac-dropdown__label">{label}</label>}

      <div className="pac-dropdown__input-wrap">
        <input
          type="text"
          className="pac-dropdown__input"
          placeholder={placeholder}
          value={search}
          onFocus={() => setShow(true)}
onChange={(e) => {
  const val = e.target.value;   

  setSearch(val);
  setShow(true);

  if (!val) {
    onChange({ target: { value: "" } });  
  }
}}
        />
        <span
          className={`pac-dropdown__arrow${show ? " pac-dropdown__arrow--open" : ""}`}
          onMouseDown={(e) => {
            e.preventDefault();
            setShow((prev) => !prev);
          }}
        >
          ▾
        </span>
      </div>

      {show && (
        <div className="pac-dropdown__menu">
          {visibleOptions.length === 0 ? (
            <div className="pac-dropdown__empty">No results found</div>
          ) : (
            visibleOptions.map((opt, i) => (
              <div
                key={i}
                className="pac-dropdown__item"
                onMouseDown={() => handleSelect(opt)}
              >
                <span className="pac-dropdown__item-id">
                  {opt[optionValue]}
                </span>
                <span className="pac-dropdown__item-name">
                  {opt[optionLabel]}
                </span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;
